/**
 * Central support email configuration.
 *
 * CRA embeds environment variables prefixed with REACT_APP_ at build time.
 * Changing REACT_APP_SUPPORT_EMAIL requires rebuilding the frontend bundle.
 */
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "social.advoset@advoset.com";
